/** Query-key conventions shared by every page; SSE invalidation relies on them. */
export const qk = {
  me: ["me"] as const,
  board: (group: string, params?: Record<string, unknown>) => ["board", group, params ?? {}] as const,
  subitems: (group: string, id: number) => ["board", group, "sub", id] as const,
  entity: (entity: string, id: number | string, part?: string) =>
    (part ? ["e", entity, id, part] : ["e", entity, id]) as readonly unknown[],
  list: (name: string, params?: Record<string, unknown>) => ["list", name, params ?? {}] as const,
  jobs: (params?: Record<string, unknown>) => ["jobs", params ?? {}] as const,
  notifications: ["notifications"] as const,
  presence: ["presence"] as const,
  settings: ["settings"] as const,
  /** identities logged in in this browser (GET /api/auth/sessions) */
  authSessions: ["auth-sessions"] as const,
};
